import { Shark, View} from "shark-mvc";
import { Collapse } from "bootstrap";

import User from "../../models/User";

import templateContent from "./sign.html";

import homeView from "../home/homeView";
import messageModalComponent from "../../components/messageModal/messageModalComponent.js";
import organizationView from "../organization/organizationView";
import systemComponent from "../../components/systemComponent";
import userManager from "../../managers/userManager.js";
import waitBoxComponent from "../../components/waitBox/waitBoxComponent";
import workSessionManager from "../../managers/workSessionManager";

class SignView extends View {
	constructor () {
		super("signView");
		this.setTemplate(templateContent);
	}

	afterLoad () {
		this.checkFocusedField();
	}

	beforeLoad () {
		const newUser = new User({});
		Shark.set({newUser});

		
		const lastUserEMail = localStorage.getItem("lastUserEMail") || "";

		const currUser = new User({
			email: lastUserEMail,
			preserveLogin: true,
		});
		
		Shark.set({
			currUser,
			retrievePasswordAccordionCSSClasses: "",
		});
	}
	
	checkFocusedField() {
		if (Shark.$store.currUser.email !== "") {
			document.querySelector("#passwordField").focus();
		}
		else {
			document.querySelector("#usernameField").focus();
		}
	}

	init () {
		this.addComponents([messageModalComponent, waitBoxComponent]);
		document.body.classList.add("theme-2");
	}

	logInBtn_clickHandler () {
		this.logInUser();
	}

	logInUser () {
		const { currUser } = Shark.get();

		console.log(currUser);

		if (currUser) {
			waitBoxComponent.open();

			const errors = currUser.validateLogin();

			if (errors.length > 0) {
				waitBoxComponent.close();
				messageModalComponent.open(errors.map(item => item.error).join("<br>"));
			}
			else {
				userManager.logIn(currUser)
				.then(loginResponse => {
					if (loginResponse.status === "ok") {
						localStorage.setItem("preserveLogin", currUser.preserveLogin);
						localStorage.setItem("lastUserEMail", currUser.email);
						
						workSessionManager.checkOpenByUser(currUser)
						.then(async () => {
							await systemComponent.prepareSystemData();

							// ALICE: Theme
							document.body.classList.remove("theme-1");
							document.body.classList.remove("theme-2");
							document.body.classList.add(currUser.preferences.theme);
							
							waitBoxComponent.close();
							if (currUser._feature_organization_create && (Shark.$store.__firstOrganizationToAdd === undefined || Shark.$store.__firstOrganizationToAdd)) {
								Shark.openPage(organizationView);
							}
							else {
								Shark.openPage(homeView);
							}
						});
					}
					else {
						waitBoxComponent.close();
						messageModalComponent.open("Qualcosa è andato storto, mi sa che hai sbagliato i dati di accesso!");
					}
				});
			}
		}
	}
	
	passwordField_keyupHandler (event) {
		if (event.which === 13) {
			this.logInUser();
		}
	}

	registerUserBtn_clickHandler () {
		const { newUser } = Shark.get();

		if (newUser.firstName === "" || newUser.lastName === "" || newUser.email === "") {
			messageModalComponent.open("Tutti i dati sono obbligatori");
			return;
		}

		if (newUser.password === "" || newUser.password !== newUser.__passwordCheck) {
			messageModalComponent.open("La password è obbligatoria e deve corrispondere a quella di verifica");
			return;
		}

		if (!newUser.__acceptPrivacyTermCondition) {
			messageModalComponent.open("È necessario leggere e accettare la Privacy policy e i Termini e Condizioni");
			return;
		}

		waitBoxComponent.open();

		newUser.guid = ""; // brutto <

		userManager.save(newUser)
		.then(saveResult => {

			if (saveResult.status === "ok") {
				localStorage.setItem("lastUserEMail", newUser.email);
				this.showSignIn();

				messageModalComponent.open(`Registrazione avvenuta, ti è stata inviata un'eMail per confermare il tuo indirizzo.`);
			}
			else {
				messageModalComponent.open(`Attenzione, non è possibile completare la registrazione con questi dati.`);
				// (`Attenzione, si sono verificati i seguenti errori:\n- ${saveResult.data.errors.map(item => item.error).join("\n- ")}`);
			}
			waitBoxComponent.close();
		});
	}
	
	async sendNewPasswordRequestBtn_clickHandler () {
		const { currUser } = Shark.get();
		
		if (currUser.email === "" || !systemComponent.checEMail(currUser.email)) {
			messageModalComponent.open("Devi inserire un indirizzo eMail valido!");
			return;
		}

		Shark.set({
			retrievePasswordAccordionCSSClasses: "disabled",
		});

		const requestResult = await userManager.requestNewPassword(Shark.$store.currUser.email);
		console.log({requestResult});

		Shark.set({
			retrievePasswordAccordionCSSClasses: "",
		});

		const bsCollapse = new Collapse("#collapseThree");
		bsCollapse.show();
	}

	showSignIn () {
		document.querySelector("#signView").classList.remove("up-active");
		this.checkFocusedField();
	}
	
	showSignUp () {
		document.querySelector("#signView").classList.add("up-active");
	}
	
	showSignInBoxBtn_clickHandler () {
		this.showSignIn();
	}

	showSignUpBoxBtn_clickHandler () {
		this.showSignUp();
	}

	validateLoginData () {
		var isValid = true;
		return isValid;
	}
}

const signView = new SignView();

Shark.registerView(signView);

export default signView;